import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import {
  getStorage,
  ref,
  listAll,
  getDownloadURL,
  uploadBytes,
} from "firebase/storage";
import {
  GoogleAuthProvider,
  signInWithPopup,
  onAuthStateChanged,
} from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { setPersistence, browserLocalPersistence } from "firebase/auth";
import firebaseConfigDev from "./firebaseConfigDev";

const firebaseConfigProduction = {
  apiKey: "AIzaSyBRwxqU4sNpsMj1N6fNBmQrv1Xwhhntc-A",
  authDomain: "rosemount-financial-solu-4f940.firebaseapp.com",
  projectId: "rosemount-financial-solu-4f940",
  storageBucket: "rosemount-financial-solu-4f940.appspot.com",
  messagingSenderId: "9919024994",
  appId: "1:9919024994:web:6618aed90255b11594a63b",
  measurementId: "G-K0Q34SQXLL",
};

const useDevelopmentFirebase =
  process.env.REACT_APP_FIREBASE_ENV?.trim().toLowerCase() === "development";

const firebaseConfig = useDevelopmentFirebase
  ? firebaseConfigDev
  : firebaseConfigProduction;

const developmentDatabaseId =
  process.env.REACT_APP_FIREBASE_DATABASE_ID?.trim() || "rosemount-dev";


// Firebase configuration
// const firebaseConfig = {
//   apiKey: "AIzaSyA9L5ybddT1yyBTlNnlMX8R-CcjXUlKVfA",
//   authDomain: "rosemount-financial-solutions.firebaseapp.com",
//   projectId: "rosemount-financial-solutions",
//   storageBucket: "rosemount-financial-solutions.appspot.com",
//   messagingSenderId: "841729471123",
//   appId: "1:841729471123:web:3a09a54683d508e1555366"
// };

// Initialize Firebase app
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
// setPersistence(auth, browserLocalPersistence).catch(console.error);

const dbProduction = getFirestore(app);
const db = useDevelopmentFirebase
  ? getFirestore(app, developmentDatabaseId)
  : dbProduction;
const dbAML = getFirestore(app, "check2-internal");
const dbFinancialPromotions = getFirestore(app, "financial-promotions");
const dbAccounts = getFirestore(app, "accounts");
const dbLOA = getFirestore(app, "letter-of-authority");
const dbParaplanning = getFirestore(app, "paraplanning");
const storage = getStorage(app);
const provider = new GoogleAuthProvider();
const analytics = getAnalytics(app);

provider.addScope("email");
provider.addScope("profile");

export {
  app,
  auth,
  db,
  dbProduction,
  dbLOA,
  dbParaplanning,
  storage,
  provider,
  dbAML,
  dbFinancialPromotions,
  dbAccounts,
  ref,
  signInWithPopup,
  listAll,
  getDownloadURL,
  uploadBytes,
  getAuth,
  onAuthStateChanged,
};
